import { Link } from "react-router-dom";

const NavBarLogo = () => {
  return (
    <Link
      className="justify-center flex flex-row flex-wrap logo-container font-MontserratBold font-bold text-5xl"
      to="/"
    >
      <span className="text-secondary">Techcycle</span>
      <span className="text-primary"> Solutions.</span>
    </Link>
  );
};

export default NavBarLogo;
